<div class="rating-distribution__summary">
	<typography variant="p/xl_medium" class="rating-distribution__score">
		{{ averageRating | number: '1.1-1' }}
	</typography>
	<div class="rating-distribution__stars">
		<ng-container *ngFor="let filled of starsArray">
			<app-icon
				type="svg"
				[size]="20"
				[color]="filled ? '#e0a82e' : '#d0d0d0'"
			>
				{{ filled ? 'star_filled' : 'star_outline' }}
			</app-icon>
		</ng-container>
	</div>
	<typography variant="p/xxs_regular" class="rating-distribution__count">
		Across {{ reviewCount | number }} reviews
	</typography>
</div>
<!-- The average comes from the platforms, the bars from the reviews we hold:
     with none held every bar was an empty track beside a real score. -->
<div class="rating-distribution__empty animation-fade-in" *ngIf="!hasCounts">
	No data available
</div>
<div class="rating-distribution__bars" *ngIf="hasCounts">
	<div class="rating-bar" *ngFor="let item of distribution">
		<typography variant="p/xxs_regular" class="rating-bar__label">
			{{ item.stars }}
		</typography>
		<app-icon type="svg" [size]="12" color="#e0a82e">star_filled</app-icon>
		<div class="rating-bar__track">
			<div
				class="rating-bar__fill"
				[style.width.%]="item.percentage"
			></div>
		</div>
		<typography variant="p/xxs_regular" class="rating-bar__count">
			{{ item.count | number }}
		</typography>
	</div>
</div>
